import { render } from "./SampleModal.vue?vue&type=template&id=760163c2"
import script from "./SampleModal.vue?vue&type=script&lang=ts"
export * from "./SampleModal.vue?vue&type=script&lang=ts"
script.render = render

export default script